/* eslint-disable max-len */
import {createApiCall} from '../utils';
import {SERVICE_NAMES} from '../constants';
import type {
    ApiCallOptions,
    PaginatedResponse,
    Account,
    ApiKey,
    CreateAccountRequest,
    UpdateAccountRequest,
    CreateSubAccountRequest,
    AccountsListParams,
    SubAccountsListParams,
    AccountsCountParams,
    GetParentAccountsParams
} from './api.d';

export const getAccountsCount = (params?: AccountsCountParams, options: ApiCallOptions = {}) => createApiCall<{count: string}>(SERVICE_NAMES.ACCOUNT, 'GET', 'accounts/count')({...options, params});

export const getAccounts = (params?: AccountsListParams, options: ApiCallOptions = {}) => createApiCall<PaginatedResponse<Account>>(SERVICE_NAMES.ACCOUNT, 'GET', 'accounts')({...options, params});

export const createAccount = (data: CreateAccountRequest, options: ApiCallOptions = {}) => createApiCall<Account>(SERVICE_NAMES.ACCOUNT, 'POST', 'accounts')({...options, data});

export const getAccount = (accountId: string, options: ApiCallOptions = {}) => createApiCall<Account>(SERVICE_NAMES.ACCOUNT, 'GET', `accounts/${accountId}`)({...options});

export const updateAccount = (accountId: string, data: UpdateAccountRequest, options: ApiCallOptions = {}) => createApiCall<Account>(SERVICE_NAMES.ACCOUNT, 'PUT', `accounts/${accountId}`)({...options, data});

export const deleteAccount = (accountId: string, options: ApiCallOptions = {}) => createApiCall<void>(SERVICE_NAMES.ACCOUNT, 'DELETE', `accounts/${accountId}`)({...options});

export const getRootAccount = (accountId: string, options: ApiCallOptions = {}) => createApiCall<Account>(SERVICE_NAMES.ACCOUNT, 'GET', `accounts/${accountId}/root-account`)({...options});

export const getParentAccounts = (accountId: string, params?: GetParentAccountsParams, options: ApiCallOptions = {}) => createApiCall<Account[]>(SERVICE_NAMES.ACCOUNT, 'GET', `accounts/${accountId}/parent-accounts`)({...options, params});

export const getApiSecretAccount = (apiSecret: string, options: ApiCallOptions = {}) => createApiCall<Account>(SERVICE_NAMES.ACCOUNT, 'GET', 'retrieve/api-secret')({...options, params: {api_secret: apiSecret}});

export const getSubAccountsApiKeys = (accountId: string, options: ApiCallOptions = {}) => createApiCall<ApiKey[]>(SERVICE_NAMES.ACCOUNT, 'GET', `accounts/${accountId}/sub-accounts/api-keys`)({...options});

export const getSubAccountsRecursive = (accountId: string, options: ApiCallOptions = {}) => createApiCall<Account[]>(SERVICE_NAMES.ACCOUNT, 'GET', `accounts/${accountId}/sub-accounts/recursive`)({...options});

export const getSubAccounts = (accountId: string, params?: SubAccountsListParams, options: ApiCallOptions = {}) => createApiCall<PaginatedResponse<Account>>(SERVICE_NAMES.ACCOUNT, 'GET', `accounts/${accountId}/sub-accounts`)({...options, params});

export const createSubAccount = (accountId: string, data: CreateSubAccountRequest, options: ApiCallOptions = {}) => createApiCall<Account>(SERVICE_NAMES.ACCOUNT, 'POST', `accounts/${accountId}/sub-accounts`)({...options, data});

export const getSubAccount = (accountId: string, subAccountId: string, options: ApiCallOptions = {}) => createApiCall<Account>(SERVICE_NAMES.ACCOUNT, 'GET', `accounts/${accountId}/sub-accounts/${subAccountId}`)({...options});

export const updateSubAccount = (accountId: string, subAccountId: string, data: UpdateAccountRequest, options: ApiCallOptions = {}) => createApiCall<Account>(SERVICE_NAMES.ACCOUNT, 'PUT', `accounts/${accountId}/sub-accounts/${subAccountId}`)({...options, data});

export const deleteSubAccount = (accountId: string, subAccountId: string, options: ApiCallOptions = {}) => createApiCall<void>(SERVICE_NAMES.ACCOUNT, 'DELETE', `accounts/${accountId}/sub-accounts/${subAccountId}`)({...options});

// Export as object for backward compatibility with tests
export const accountApi = {
    getAccountsCount,
    getAccounts,
    createAccount,
    getAccount,
    updateAccount,
    deleteAccount,
    getRootAccount,
    getParentAccounts,
    getApiSecretAccount,
    getSubAccountsApiKeys,
    getSubAccountsRecursive,
    getSubAccounts,
    createSubAccount,
    getSubAccount,
    updateSubAccount,
    deleteSubAccount
};
